import { GetCompanyData, GetCompanyInfo } from "./api/company-endpoints";
import { excelCompanyDataRequest } from "@/models/excel-udf-request-objects/excelCompanyDataRequest";
import { excelCompanyDataInfoRequest } from "@/models/excel-udf-request-objects/excelCompanyDataInfoRequest";

export const COMPANY_DATA_INFO: string = "COMPANY_DATA_INFO";
export const COMPANY_DATA: string = "COMPANY_DATA";

export type validKeyType = excelCompanyDataRequest | excelCompanyDataInfoRequest;

export function retrieveHydrator(objectType:string) {
    switch(objectType){
        case COMPANY_DATA_INFO: return GetCompanyInfo;
        case COMPANY_DATA: return GetCompanyData;
        default: return null;
    }
}